import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Loader2, Inbox, ChevronRight } from "lucide-react";

const fmtPrice = (v) => (v == null || v === "" ? "—" : new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(Number(v)));

export default function CompanyMyListPanel({ dealerId, scope, onOpen }) {
    const [data, setData] = useState(null);
    const [busy, setBusy] = useState(true);

    useEffect(() => {
        let on = true;
        setBusy(true);
        api.get(`/vermittler/company/${dealerId}/my/${scope}`)
            .then((r) => { if (on) setData(r.data); })
            .catch(() => { if (on) setData({ items: [], columns: [] }); })
            .finally(() => { if (on) setBusy(false); });
        return () => { on = false; };
    }, [dealerId, scope]);

    if (busy) return <div className="flex items-center justify-center py-10 text-gray-400" data-testid={`company-my-${scope}-loading`}><Loader2 className="w-5 h-5 animate-spin" /></div>;
    const items = data?.items || [];
    const cols = data?.columns || [];

    if (!items.length) {
        return (
            <div className="flex flex-col items-center justify-center py-12 text-gray-400" data-testid={`company-my-${scope}-empty`}>
                <Inbox className="w-8 h-8 mb-2" />
                <p className="text-sm">Aktuell keine Einträge.</p>
            </div>
        );
    }

    return (
        <div className="overflow-x-auto" data-testid={`company-my-${scope}-list`}>
            <table className="w-full text-sm">
                <thead>
                    <tr className="border-b border-gray-200">
                        {cols.map((c) => (
                            <th key={c.key} className={`px-3 py-2 text-[10px] uppercase tracking-wider font-bold text-gray-500 ${c.type === "price" ? "text-right" : "text-left"}`}>{c.label}</th>
                        ))}
                        <th className="w-8" />
                    </tr>
                </thead>
                <tbody>
                    {items.map((row) => (
                        <tr
                            key={row.id}
                            onClick={() => row.link && onOpen?.(row.link)}
                            className={`border-b border-gray-100 ${row.link ? "cursor-pointer hover:bg-[#FFFBEB]" : ""}`}
                            data-testid={`company-my-${scope}-row-${row.id}`}
                        >
                            {cols.map((c) => (
                                <td key={c.key} className={`px-3 py-2.5 ${c.type === "price" ? "text-right font-bold tabular-nums" : "text-gray-800"}`}>
                                    {c.type === "price" ? fmtPrice(row[c.key]) : (row[c.key] ?? "—")}
                                </td>
                            ))}
                            <td className="px-2 text-gray-300">{row.link && <ChevronRight className="w-4 h-4" />}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
